(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-onEvent-scripts', {
                parent: 'update_management',
                url: '/tab-onEvent-scripts',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'global.menu.entities.tabOnEventScripts'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-onEvent-scripts/tab-onEvent-scripts.html',
                        controller: 'TabOnEventScriptsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabOnEventScripts');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

    }
})();
